import Footer from "@/components/Footer";
import Navbar from "@/components/Navbar";
import React from "react";

const PrivacyPolicy = () => {
  return (
    <>
      <Navbar />
      <div className="min-h-screen bg-white">
        {/* HERO */}
        <section className="py-20 bg-emerald-900 text-white text-center">
          <h1 className="text-5xl font-bold mb-4">Privacy Policy</h1>
          <p className="text-emerald-100 max-w-2xl mx-auto">
            We value your privacy and are committed to protecting your personal
            information.
          </p>
        </section>

        {/* CONTENT */}
        <section className="max-w-5xl mx-auto px-6 py-16 space-y-10 text-gray-700">
          <div>
            <h2 className="text-2xl font-bold mb-2">
              1. Information We Collect
            </h2>
            <p>
              We may collect personal details such as name, email, phone number,
              and message when you contact us through our website forms.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold mb-2">
              2. How We Use Information
            </h2>
            <p>
              Your information is used to respond to inquiries, provide
              services, and improve customer experience.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold mb-2">3. Data Protection</h2>
            <p>
              We implement strict security measures to protect your data from
              unauthorized access or misuse.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold mb-2">4. Cookies</h2>
            <p>
              Our website may use cookies to improve user experience and analyze
              website traffic.
            </p>
          </div>

          {/* <div>
            <h2 className="text-2xl font-bold mb-2">5. Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy, contact us at{" "}
              <a
                href="mailto:contact@innorviatechnology.com"
                className="text-emerald-600 hover:underline"
              >
                contact@innorviatechnology.com
              </a>
            </p>
          </div> */}
        </section>
      </div>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;
